import React from 'react'
import { Row, Col, Button } from 'reactstrap'
import { Stack } from "phosphor-react"
import { withTranslation } from 'react-i18next'
import { processError } from '../../lib/lib'
import api from '../../api/api'
import PropTypes from 'prop-types'
import CatalogMiniCard from '../../components/Catalog/CatalogMiniCard.jsx'
import AuthorMiniCard from '../../components/Authors/AuthorMiniCard.jsx'
import Cookies from 'universal-cookie'
import Skeleton from '../../components/UI/Skeleton'
const cookies = new Cookies()

class AuthorDesc extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            page: 1,
            limit: 2,
            // eslint-disable-next-line no-undef
            imageUrl: process.env.REACT_APP_IMAGEURL,
            authorInfo: {
                image: '',
                title: '',
                desc: '',
                courses: [],
                guidance: [],
            },
            authorInfoLoaded: false,
        }
        this.routeToCatalog = this.routeToCatalog.bind(this)
    }

    routeToCatalog() {
        this.props.history.push('/catalog')
    }

    getTeacherInfo(id, token, lang) {
        return new Promise((resolve, reject) => {
            api.getTeacherInfo(id, token, lang)
                .then((res) => resolve(res))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    async componentWillMount() {
        const token = cookies.get('accessToken')
        const lang = this.props.i18n.language
        let arrPromise = [
            this.getTeacherInfo(this.props.match.params.authorId, token, lang).then((teacherInfo) => {
                this.setState({ authorInfo: teacherInfo, authorInfoLoaded: true })
            }),
        ]
        Promise.all(arrPromise)
    }

    render() {
        const { t } = this.props
        return (
            <div>
                <div className="content grey-bg">
                    <Row>
                        <Col xs={12} md={12}>
                            <div className="col-xl-12">
                                <section>
                                    <div className="row author-main">
                                        <div className="pt-20 col-sm-12 col-md-8">
                                            {
                                                this.state.authorInfoLoaded ?
                                                    <div className="main-link md-font-size">{t('authors-curators')} / {this.state.authorInfo.title}</div>
                                                    :
                                                    <div className="main-link md-font-size">
                                                        <Skeleton width={'30%'} />
                                                    </div>

                                            }

                                            {
                                                this.state.authorInfoLoaded ?
                                                    <React.Fragment>
                                                        {this.state.authorInfo.content && <div className="author content-wrapper md-font-size" dangerouslySetInnerHTML={{ __html: this.state.authorInfo.content }} />}
                                                    </React.Fragment>
                                                    :
                                                    <div className="author content-wrapper md-font-size">
                                                        <Skeleton count={5} />
                                                    </div>
                                            }

                                            {
                                                this.state.authorInfoLoaded ?
                                                    <React.Fragment>
                                                        {
                                                            this.state.authorInfo.guidance.length ?
                                                                <div className="body">
                                                                    <div className="lesson-title xl-font-size">{t('authors-recommend-personal')}</div>
                                                                    <div className="catalog-row-wrapper">
                                                                        {
                                                                            this.state.authorInfo.guidance.length ?
                                                                                this.state.authorInfo.guidance.map((item) => (
                                                                                    <CatalogMiniCard key={item.id}
                                                                                        id={item.id}
                                                                                        image={item.image}
                                                                                        title={item.title}
                                                                                        desc={item.desc}
                                                                                        price={item.newPrice}
                                                                                        type={item.type}
                                                                                        typeId={item.typeId}
                                                                                        props={this.props}
                                                                                    />
                                                                                )) :
                                                                                <div className="empty__catalog lg-font-size">{t('catalog-empty')}</div>
                                                                        }
                                                                        <div className="d-flex justify-content-center">
                                                                            <Button type="button" className="btn profile-avatar-btn primary watch-all" onClick={this.routeToCatalog}>
                                                                                <Stack size={20} />
                                                                                <span className="pl-5px sm-font-size">{t('authors-recommend-see')}</span>
                                                                            </Button>
                                                                        </div>
                                                                    </div>
                                                                </div> : ""
                                                        }
                                                    </React.Fragment>
                                                    :
                                                    <div className="body">
                                                        <div className="lesson-title xl-font-size">
                                                            <Skeleton width={'50%'} />
                                                        </div>
                                                        <div className="catalog-row-wrapper d-flex">
                                                            <CatalogMiniCard skeleton={true} />
                                                            <CatalogMiniCard skeleton={true} />
                                                            <CatalogMiniCard skeleton={true} />
                                                        </div>
                                                    </div>
                                            }
                                        </div>
                                        <div className="pt-20 col-sm-12 col-md-4">
                                            <div className="card author-mini-card mb-40">
                                                {
                                                    this.state.authorInfoLoaded ?
                                                        <React.Fragment>
                                                            <div className="card-header p-0">
                                                                <img className="card-img" src={this.state.authorInfo.image ? `${this.state.imageUrl}/${this.state.authorInfo.image}` : "data:,"} alt="" />
                                                            </div>
                                                            <div className="card-body p-0">
                                                                <div className="title xl-font-size">{this.state.authorInfo.title}</div>
                                                                <div className="desc md-font-size" dangerouslySetInnerHTML={{ __html: this.state.authorInfo.desc }}></div>
                                                            </div>
                                                        </React.Fragment>
                                                        :
                                                        <React.Fragment>
                                                            <div className="card-header p-0">
                                                                <Skeleton className="card-img" height={320} />
                                                            </div>
                                                            <div className="card-body p-0">
                                                                <div className="title xl-font-size">
                                                                    <Skeleton />
                                                                </div>
                                                                <div className="desc md-font-size">
                                                                    <Skeleton />
                                                                </div>
                                                            </div>
                                                        </React.Fragment>
                                                }
                                            </div>

                                            {
                                                this.state.authorInfoLoaded ?
                                                    this.state.authorInfo.courses.length ?
                                                        <div className="courses-wrapper">
                                                            <div className="title lg-font-size">{t('authors-supervise')}</div>
                                                            <div className="courses-list">
                                                                {
                                                                    this.state.authorInfo.courses.length ?
                                                                        this.state.authorInfo.courses.map((course) => (
                                                                            <AuthorMiniCard key={course.id}
                                                                                id={course.id}
                                                                                title={course.title}
                                                                                desc={course.desc}
                                                                                props={this.props}
                                                                            />
                                                                        )) :
                                                                        <div className="empty__programs lg-font-size">{t('catalog-empty-programs')}</div>
                                                                }
                                                            </div>
                                                        </div> : ""
                                                    :
                                                    <div className="courses-wrapper">
                                                        <div className="title lg-font-size">{t('authors-supervise')}</div>
                                                        <div className="courses-list">
                                                            <AuthorMiniCard skeleton={true} />
                                                            <AuthorMiniCard skeleton={true} />
                                                        </div>
                                                    </div>
                                            }

                                        </div>
                                    </div>
                                </section>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}

AuthorDesc.propTypes = {
    t: PropTypes.func,
    i18n: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
}

export default withTranslation()(AuthorDesc)



// WEBPACK FOOTER //
// ./src/views/Authors/AuthorDesc.jsx